'use client';

import { Image } from '@ahafood/ui/components/image';
import { useState } from 'react';

interface ImageWithFallbackProps
  extends Omit<React.ComponentProps<typeof Image>, 'src'> {
  src: string;
  fallbackSrc: string;
}

export default function ImageWithFallback({
  src,
  fallbackSrc,
  alt,
  ...rest
}: ImageWithFallbackProps) {
  const [imgSrc, setImgSrc] = useState(
    src && src.trim() !== '' ? src : fallbackSrc
  );

  return (
    <Image
      {...rest}
      src={imgSrc}
      alt={alt}
      onError={() => {
        setImgSrc(fallbackSrc);
      }}
    />
  );
}
